import React, { useState, useEffect } from 'react';
import './userdb.scss';
import { AuthContext } from "../../../authcontext/authContext";
import { makeRequest } from "../../../axios";



const TransactionTable = () => {


  // Sample transaction data
  const [transactions, setTransactions] = useState([]);

  const [sortConfig, setSortConfig] = useState({ key: '', direction: '' });
  const [filterType, setFilterType] = useState('All');

  useEffect(() => {
    makeRequest.get("user-info/alltransactions").then((res) => {
      setTransactions(res.data);
    });
  }, []);

  // Sort transactions based on selected column
  const sortedTransactions = [...transactions].sort((a, b) => {
    if (sortConfig.key) {
      const order = sortConfig.direction === 'ascending' ? 1 : -1;
      return a[sortConfig.key] > b[sortConfig.key] ? order : -order;
    }
    return 0;
  });

  // Filter transactions based on transaction type
  const filteredTransactions = filterType === 'All'
    ? sortedTransactions
    : sortedTransactions.filter(transactions => transactions.type === filterType);

  // Toggle sorting direction
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.direction === 'ascending' ? 'descending' : 'ascending',
    }));
  };

  return (
    <div className="transaction-table-container">
      <h2>User Transactions</h2>

      <table className="transaction-table">
        <thead>
          <tr>
            <th onClick={() => handleSort('date')}>
              Currency {sortConfig.key === 'date' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}
            </th>
            <th onClick={() => handleSort('type')}>
              Type {sortConfig.key === 'type' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}
            </th>
            <th onClick={() => handleSort('amount')}>
              Amount {sortConfig.key === 'amount' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}
            </th>
            <th onClick={() => handleSort('status')}>
              Status {sortConfig.key === 'status' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}
            </th>
            <th onClick={() => handleSort('received')}>
              Time {sortConfig.key === 'received' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}
            </th>
            <th onClick={() => handleSort('category')}>
              Remarks {sortConfig.key === 'category' ? (sortConfig.direction === 'ascending' ? '▲' : '▼') : ''}
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredTransactions.map((transaction) => (
            <tr key={transaction.transaction_id}>
              <td>{transaction.method_details}</td>
              { transaction.type === "DEPOSIT" ? <td style={{color:"green"}}>{transaction.type}</td> : <td style={{color:"red"}}>{transaction.type}</td> }
              <td>{transaction.amount}</td>
              <td>{transaction.trans_status}</td>
              <td>{transaction.received}</td>
              <td>{transaction.category}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TransactionTable;
